module.exports = __webpack_public_path__ + "static/media/ServiceBGM.657e74aa.jpg";